import { SET_NOTIFICATION_CENTER, TOGGLE_NOTIFICATION_CENTER_VISIBILITY } from '@src/redux/actions/notificationCenter';

const DEFAULT_STATE = {
  isVisible: false,
  newNotificationsCount: 0,
  readNotificationsCount: 0,
  totalNotificationsCount: 0,
  unreadNotificationsCount: 0,
};

export function notificationCenter(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_NOTIFICATION_CENTER:
      return {
        ...state,
        newNotificationsCount: action.notificationCenter.newNotificationsCount,
        readNotificationsCount: action.notificationCenter.readNotificationsCount,
        totalNotificationsCount: action.notificationCenter.totalNotificationsCount,
        unreadNotificationsCount: action.notificationCenter.unreadNotificationsCount,
      };
    case TOGGLE_NOTIFICATION_CENTER_VISIBILITY:
      return { ...state, isVisible: !state.isVisible };
    default:
      return state;
  }
}
